<template>
    <label class="font-medium text-primary dark:text-white" :class="label_class">{{ label }}</label>
    <input
        :id="id"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :class="input_class"
        :value="modelValue"
        :disabled="disable_input"
        @input="$emit('update:modelValue', $event.target.value)"
        class="block mt-1 flex-1 border border-primary dark:border-white rounded-md px-3 py-2 text-primary dark:text-white placeholder:text-primary dark:placeholder:text-white focus:outline-none dark:focus:bg-dark-900 dark:bg-dark-900"
        :max="max"
        :min="min"
    >
</template>

<script>
export default {
    name: 'InputText',
    props: {
        label: String,
        label_class: String,
        id: String,
        type: String,
        name: String,
        placeholder: String,
        input_class: String,
        modelValue: String,
        disable_input: Boolean,
        max: Number,
        min: Number,
    },
    emits: ['update:modelValue'],
}
</script>